module.exports = __webpack_public_path__ + "media/components/common/GrowthPlatform/abstract-shape-001-ef9eae168e3d47bb4b410e97aaddca6d.svg";